module.exports = __webpack_public_path__ + "img/25Ox25O.d41d8cd9.svg";